module.exports = __webpack_public_path__ + "static/img/dyItem3.e8d5d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/dyItem3.png
// module id = QxF0
// module chunks = 0